/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { boardViewNotFoundPageEntrypoint } from '@jira/spa-apps__error-pages-board-view-not-found/src/boardViewNotFoundPageEntrypoint.entrypoint.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { softwareBoardViewNotFoundRoute } from '@jira/router-routes__software-view-not-found-routes/src/softwareBoardViewNotFoundRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareBoardViewNotFoundRouteEntry: Route = createEntry(
	softwareBoardViewNotFoundRoute,
	() => ({
		group: 'software',
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
		],

		entryPoint: () => boardViewNotFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
